import { STORAGE_KEYS } from "./constants";

const getSavedInfo = fieldName => {
    let returnValue = localStorage.getItem(fieldName);
    if (!returnValue) returnValue = sessionStorage.getItem(fieldName);
    return returnValue;
};

const clearSavedInfo = () => {
    const ignoreList = [
        STORAGE_KEYS.UPLOAD_EDITION,
        STORAGE_KEYS.UPLOAD_FORM_DEFINITION,
        STORAGE_KEYS.UPLOAD_FORM_GROUP,
        STORAGE_KEYS.UPLOAD_TEMPLATE_SORTING,
        STORAGE_KEYS.UPLOAD_PREBUILT_DEFINITION,
        STORAGE_KEYS.UPLOAD_TEAM,
    ]
    for (let key of Object.values(STORAGE_KEYS)) {
        if (ignoreList.includes(key)) {
            continue;
        }
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
    }
};

export default { getSavedInfo, clearSavedInfo };
